import { render } from "./MoreDetailsRoster23Screen.vue?vue&type=template&id=e243ecec&scoped=true"
import script from "./MoreDetailsRoster23Screen.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster23Screen.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster23Screen.vue?vue&type=style&index=0&id=e243ecec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e243ecec"]])

export default __exports__